import type { RefObject } from 'react';
import { useMemo } from 'react';

export function useIsOverflowed(ref: RefObject<HTMLElement>) {
  return useMemo(() => {
    if (ref.current) {
      return ref.current.scrollWidth - 1 > ref.current.clientWidth;
    }

    return false;
  }, [ref.current?.scrollWidth, ref.current?.clientWidth]);
}